import React from "react";
import { TIER_ROWS, AI_TIERS } from "@/constants/aiTiersCatalog";

const TierHeaderCell = ({ tier }) => (
  <div className="p-4 sm:p-5 border-l border-partner text-center">
    <span className="badge-mono text-partner-accent text-[10px]">TIER {tier.id}</span>
    <p className="text-[10px] font-mono text-partner-muted uppercase mt-1">{tier.badge}</p>
    <p className="font-bold text-partner text-sm sm:text-base mt-1">{tier.name}</p>
  </div>
);

const TierValueCell = ({ value, highlight }) => (
  <div
    className={`p-4 sm:p-5 border-l border-partner text-xs sm:text-sm font-body leading-relaxed ${
      highlight ? "text-partner-accent font-semibold" : "text-partner"
    }`}
  >
    {value}
  </div>
);

const TierCard = ({ tier, rows }) => (
  <div className="rounded-xl border border-partner bg-[#11151F] overflow-hidden" data-testid={`tier-card-${tier.id}`}>
    <div className="p-4 border-b border-partner bg-[#080A0F]/50 text-center">
      <span className="badge-mono text-partner-accent text-[10px]">TIER {tier.id}</span>
      <p className="text-[10px] font-mono text-partner-muted uppercase mt-1">{tier.badge}</p>
      <p className="font-bold text-partner text-base mt-1">{tier.name}</p>
    </div>
    {rows.map((row) => (
      <div
        key={row.label}
        className={`p-4 border-b border-partner last:border-b-0 ${row.highlight ? "bg-[#00D2FF]/8" : ""}`}
      >
        <p className="text-[10px] font-mono tracking-wider text-partner-muted uppercase mb-1.5">
          {row.label}
        </p>
        <p
          className={`text-sm font-body leading-relaxed ${
            row.highlight ? "text-partner-accent font-semibold" : "text-partner"
          }`}
        >
          {row[`tier${tier.id}`]}
        </p>
      </div>
    ))}
  </div>
);

const TierComparisonTable = ({ className = "" }) => (
  <div className={className}>
    {/* Desktop: 4-column table */}
    <div className="hidden lg:block bento-card overflow-hidden border border-partner">
      <div className="grid grid-cols-4 border-b border-partner bg-[#11151F]">
        <div className="p-4 sm:p-5" />
        {AI_TIERS.map((tier) => (
          <TierHeaderCell key={tier.id} tier={tier} />
        ))}
      </div>

      {TIER_ROWS.map((row, index) => (
        <div
          key={row.label}
          className={`grid grid-cols-4 border-b border-partner last:border-b-0 ${
            row.highlight ? "bg-[#00D2FF]/8" : index % 2 === 0 ? "" : "bg-[#11151F]"
          }`}
        >
          <div className="p-4 sm:p-5 text-xs sm:text-sm font-semibold text-partner-muted">
            {row.label}
          </div>
          <TierValueCell value={row.tier1} highlight={row.highlight} />
          <TierValueCell value={row.tier2} highlight={row.highlight} />
          <TierValueCell value={row.tier3} highlight={row.highlight} />
        </div>
      ))}
    </div>

    {/* Mobile / tablet: stacked cards */}
    <div className="lg:hidden grid gap-4 sm:grid-cols-2">
      {AI_TIERS.map((tier) => (
        <TierCard key={tier.id} tier={tier} rows={TIER_ROWS} />
      ))}
    </div>
  </div>
);

export default TierComparisonTable;
